import {
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Alert from "@material-ui/lab/Alert";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Fetchable } from "../../interfaces";

interface DeleteDialogProps {
  onClose: () => any;
  id: string;
  isOpen: boolean;
  deleteAction: ActionCreatorWithPayload<any, string>;
  selector: (state: any) => Partial<Fetchable<any>>;
  dialogTitle?: string;
  dialogMessage?: string;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  isOpen,
  onClose,
  id,
  deleteAction,
  selector,
  dialogTitle,
  dialogMessage,
}) => {
  const [alertOpen, setOpen] = useState(true);
  const [hasBeenRequested, setHasBeenRequested] = useState(false);
  const dispatch = useDispatch();
  const currentSelector = useSelector(selector);

  useEffect(() => {
    setHasBeenRequested(false);
  }, [isOpen]);

  const deleteConfirmed = () => {
    dispatch(deleteAction(id));
    setHasBeenRequested(true);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        {dialogTitle ? dialogTitle : "Vuoi procedere all'eliminazione?"}
      </DialogTitle>
      <DialogContent>
        {dialogMessage ? dialogMessage : ""}
        <DialogContentText>
          <Collapse
            in={!currentSelector.isLoading && hasBeenRequested && alertOpen}
          >
            <Alert
              color={currentSelector.error ? "error" : "success"}
              severity={currentSelector.error ? "error" : "success"}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {currentSelector.error
                ? "Si è verificato un errore"
                : "Eliminazione effettuata"}
            </Alert>
          </Collapse>
        </DialogContentText>
        <DialogActions>
          {!currentSelector.data ? (
            <>
              <Button color="secondary" onClick={onClose}>
                No
              </Button>
              <Button color="primary" onClick={deleteConfirmed}>
                Si
              </Button>
            </>
          ) : (
            <Button color="secondary" onClick={onClose}>
              Chiudi
            </Button>
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDialog;
